import { DiscordMountContentFrameDispatcher } from '../dispatchers/DiscordMountContentFrameDispatcher.ts';
export class DiscordMountSDKEventListener {
    subscribe(event) {
        if (event == undefined) throw new Error('Event is missing');
        if (this.subscriptions.has(event)) return;
        void this.discordSDK.subscribe(event, (eventData)=>{
            DiscordMountContentFrameDispatcher.notifyWhenDiscordEventTriggers(event, eventData);
        });
        this.subscriptions.add(event);
    }
    unsubscribe(event) {
        if (event == undefined) throw new Error('Event is missing');
        if (!this.subscriptions.has(event)) return;
        void this.discordSDK.unsubscribe(event, (eventData)=>{
            DiscordMountContentFrameDispatcher.notifyWhenDiscordEventTriggers(event, eventData);
        });
        this.subscriptions.delete(event);
    }
    constructor(discordSDK){
        this.subscriptions = new Set();
        this.discordSDK = discordSDK;
    }
}
